"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonMaskPlugin = void 0;

var tslib_1 = require("tslib");

var PolygonMaskInstance_1 = require("./PolygonMaskInstance");

var PolygonMask_1 = require("./Options/Classes/PolygonMask");

var Enums_1 = require("./Enums");

var PolygonMaskPlugin = /*#__PURE__*/function () {
  function PolygonMaskPlugin() {
    _classCallCheck(this, PolygonMaskPlugin);

    this.id = "polygonMask";
  }

  _createClass(PolygonMaskPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new PolygonMaskInstance_1.PolygonMaskInstance(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      return (_b = (_a = options === null || options === void 0 ? void 0 : options.polygon) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : ((_c = options === null || options === void 0 ? void 0 : options.polygon) === null || _c === void 0 ? void 0 : _c.type) !== undefined && options.polygon.type !== Enums_1.Type.none;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      if (!this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;
      var polygonOptions = optionsCast.polygon;

      if ((polygonOptions === null || polygonOptions === void 0 ? void 0 : polygonOptions.load) === undefined) {
        optionsCast.polygon = polygonOptions = new PolygonMask_1.PolygonMask();
      }

      polygonOptions.load(source === null || source === void 0 ? void 0 : source.polygon);
    }
  }]);

  return PolygonMaskPlugin;
}();

var plugin = new PolygonMaskPlugin();
exports.PolygonMaskPlugin = plugin;

tslib_1.__exportStar(require("./Enums"), exports);